import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Container, Row } from 'react-bootstrap';
import GenericCards from '../../../components/GenericCards';

const listInfo = [
  'a. Ensure your data is correct',
  'b. Have already decided on your retirement date, beneficiary and optional payment form',
  'c. Have your Paperwork Ready',
];

function Summary() {
  return (
    <Container className={'p-0'}>
      <Row className={'align-items-center mt-lg-10'}>
        <Col className="col-12 col-lg-5">
          <div>
            <img
              className={'d-block mx-auto w-100'}
              src={`${process.env.PUBLIC_URL}/${'benefit-img.svg'}`}
              alt={'Pension election checklist'}
            />
          </div>
        </Col>
        <Col className={'col-12 col-lg-7'}>
          <Container className={'ps-lg-7 px-0'}>
            <Row>
              <Col>
                <GenericCards
                  variant="transperant"
                  className={'d-flex flex-column p-0 mt-10 mt-lg-0 '}
                >
                  <h5 className={'text-nowrap text-sm-20-lg-24'}>Checklist</h5>
                  {listInfo.map((info, index) => {
                    return (
                      <div
                        key={index}
                        className={
                          'fw-normal text-caption lh-xs pt-3 d-flex align-items-center'
                        }
                      >
                        <FontAwesomeIcon
                          icon={light('check')}
                          className="pe-7"
                        />
                        <span className={'text-fs-6 lh-sm '}>{info}</span>
                      </div>
                    );
                  })}
                </GenericCards>
              </Col>
            </Row>
          </Container>
        </Col>
      </Row>
    </Container>
  );
}

export default Summary;
